<script setup>
import { onMounted } from 'vue';
import { Icon } from "@iconify/vue";
import {router} from "@inertiajs/vue3";

onMounted(() => {
    const legitScriptElement = document.getElementById('legitScript');
    var url = location.protocol + '//static.legitscript.com';
    legitScriptElement.innerHTML = `
    <a href="https://www.legitscript.com/websites/?checker_keywords=showw.com" target="_blank" title="Verify LegitScript Approval">
        <img src="${url}/seals/20918189.png" alt="LegitScript approved" width="140" height="120" border="0" />
    </a>
`;
});
</script>

<template>
    <footer>
        <section class="py-10 px-4 bg-[#2F4F4E]">
            <div class="text-white">
                <div class="flex flex-col md:flex-row content-start justify-center items-center md:items-start space-y-4 md:space-y-0 md:space-x-16">
                    <div class="flex flex-col items-center md:items-start">
                        <a href="/" class="pb-2"><img src="/images/footer-logo.png" width="175" alt="" class="image-29"/></a>
                        <a href="tel:18885857712">(888) 585-7712</a>
                        <a href="mailto:support@showw.com">support@showw.com</a>
                        <h6 class="text-center md:text-left text-white mt-4 mb-2 text-2xl">Follow Us</h6>
                        <div class="flex flex-row space-x-4 justify-center md:justify-start">
                            <a href="https://www.facebook.com/joinshoww/" target="_blank" class="max-w-10">
                                <img src="/images/footer/facebook-logo-button.svg" loading="lazy" width="100" alt=""/>
                            </a>
                            <a href="https://www.instagram.com/joinshoww/" target="_blank" class="max-w-10">
                                <img src="/images/footer/instagram.svg" loading="lazy" width="100" alt=""/>
                            </a>
                            <a href="https://www.tiktok.com/@joinshoww" class="max-w-10">
                                <img src="/images/footer/tiktok.png" loading="lazy" width="100" alt=""/>
                            </a>
                        </div>
                    </div>
                    <div class="flex flex-col">
                        <h6 class="text-white text-2xl pb-5">WEIGHT LOSS</h6>
                        <div class="flex flex-col items-center md:items-start space-y-1">
                            <a href="/shopping-semaglutide/" class="link-5">Semaglutide</a>
                            <a href="/shopping-tirzepatide/" class="link-5">Tirzepatide</a>
                        </div>
                    </div>
                    <div class="flex flex-col">
                        <h6 class="text-white text-2xl pb-5">CONTACT US</h6>
                        <div class="flex flex-col items-center md:items-start space-y-1">
                            <a href="mailto:support@showw.com" class="link-5">Send an Email</a>
                            <a :href="route('welcome')" class="link-5">Instructions</a>
                            <a :href="route('faqs')" class="link-5">FAQs</a></div>
                    </div>
                    <div class="flex flex-col">
                        <div class="flex flex-col items-center md:items-center space-y-2">
                            <img src="/images/footer/hipaa-training.svg" alt="HIPAA Training Certified"/>
                            <div class="" id="legitScript">

                            </div>
                            <img class="max-w-[205px]" src="/images/cardlogos.png">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="px-4 py-6 bg-[#2F4F4E] text-[#466e6c] border-t-[#466e6c]" style="border-top-width: 1px;">
            <div class="max-w-[900px] md:flex md:flex-row md:justify-between md:m-auto">
                <p class="text-center">© <span class="current-year">2023-2025</span> SHOWW, LLC. All rights reserved</p>
                <div class="flex flex-col text-center md:text-left md:flex-row md:space-x-4"><a href="https://showw.com/legal/terms" class="link-7">Terms &amp; Conditions</a><a href="https://showw.com/legal/privacy" class="link-7">Privacy Policy</a><a href="https://showw.com/legal/telehealth-consent" class="link-7 last_link">Telehealth</a></div>

            </div>
        </section>
    </footer>
</template>
